import styled from 'styled-components';
import { SmallButton } from './TaskManager.styles';

const TableWrapper = styled.div``;

const TableLayout = styled.table`
  width: 100%;
  margin: auto;
  text-align: left;
  border-spacing: 0;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
`;

const TableHeader = styled.th`
  padding-left: 24px;
  font-weight: 600;
  height: 72px;
  vertical-align: middle;
  background-color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const IconWrapper = styled.span`
  margin-right: auto;
  min-width: 28px;
`;

const Row = styled.tr<{ darkBg?: boolean }>`
  padding-right: 12px;
  vertical-align: middle;
  background-color: ${({ darkBg = false }) => (darkBg ? '#F7F8FA' : '#FFFFFF')};
  ${({ onClick }) =>
    onClick &&
    `&:hover {
    cursor: pointer;
    background-color: #dcdfe6;
    }`}
`;

const NoDataRow = styled(Row)`
  text-align: center;
  height: 100px;
`;

const ColumnWrapper = styled.td<{ width?: string }>`
  padding-left: 24px;
  height: 100%;
  ${({ width }) => (width ? 'width: 100%' : undefined)};
`;

const Column = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  width: 100%;
  padding-right: 14px;
  white-space: nowrap;
`;

const TruncatedTextWrapper = styled.div<{ maxWidth?: string }>`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}` : '300px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Assignee = styled(Column)`
  & > svg {
    margin: 6px;
    &:hover {
      cursor: pointer;
    }
  }
`;

const TaskNotes = styled(Column)`
  & > svg {
    margin: 6px;
    &:hover {
      cursor: pointer;
    }
  }
`;

const Priority = styled(Column)`
  & > svg {
    margin: 6px;
  }
`;

const ActionButton = styled(SmallButton)`
  color: white;
  font-weight: bold;
  background-color: #1d4586;
  margin-right: 6px;

  &:hover {
    background-color: #4577cd;
  }
`;

const ActionButtonOutline = styled(SmallButton)`
  color: #1d4586;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid #1d4586;

  &:hover {
    color: #4577cd;
    border-color: #4577cd;
  }

  &:disabled {
    color: lightgray;
    border-color: lightgray;
  }
`;

const PaginationButtonWrapper = styled.div`
  width: 100%;
  margin: auto;
  text-align: center;
  padding: 24px;
`;

export {
  TableWrapper,
  TableHeader,
  Row,
  Column,
  TableLayout,
  Assignee,
  ActionButton,
  ActionButtonOutline,
  ColumnWrapper,
  TruncatedTextWrapper,
  IconWrapper,
  NoDataRow,
  PaginationButtonWrapper,
  TaskNotes,
  Priority,
};
